import { render, staticRenderFns } from "./DashboardEsg.vue?vue&type=template&id=ad8d72d2"
import script from "./DashboardEsg.vue?vue&type=script&lang=js"
export * from "./DashboardEsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DashboardEsg.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSurveyEsgSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/EsgSectionTitle.vue').default,IxSurveyEsgScore: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/EsgScore.vue').default,IxSurveyEsgScoreSectionDetails: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/EsgScoreSectionDetails.vue').default,IxDisclosure: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Disclosure.vue').default,EsgQuestionarieResult: require('/home/runner/work/assessment-service/assessment-service/frontend/components/esg/QuestionarieResult.vue').default})
